import { render, staticRenderFns } from "./payments-editor-costs.vue?vue&type=template&id=a66dcf6e"
import script from "./payments-editor-costs.vue?vue&type=script&lang=js"
export * from "./payments-editor-costs.vue?vue&type=script&lang=js"
import style0 from "./payments-editor-costs.vue?vue&type=style&index=0&id=a66dcf6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports